"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMinor = exports.convertToMajor = exports.getIsSymbolAfter = exports.getCurrencyMultiplier = exports.getCurrencyDecimals = exports.CURRENCY_UNITS_DICT = exports.formatCurrency = exports.getDisplayCurrency = exports.getDisplayCurrencyWithLanguageCountry = exports.getDisplayCurrencyWithLocale = void 0;
const common_1 = require("../common");
// allow spaces in the following currencies
const CURRENCY_CODES_TO_ALLOW_SPACES = ['CHF', 'CAD'];
/**
 * Formats an amount as a currency based on given currency code and locale. Shows decimal based on flag.
 *
 * @param {number} amount
 * @param {string} currency
 * @param {string} locale
 * @return {string}
 * @deprecated Still available, but direct use of this function is being deprecated.  Use formatCurrency instead.
 */
exports.getDisplayCurrencyWithLocale = (amount, currency, locale, showDecimalPlaces) => {
    if (amount !== null && amount !== undefined && !isNaN(Number(amount))) {
        if (currency) {
            const minimumFractionDigits = showDecimalPlaces ? 2 : 0;
            const maximumFractionDigits = showDecimalPlaces ? 2 : 0;
            const formattedCurrency = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
                minimumFractionDigits,
                maximumFractionDigits
            }).format(amount);
            // we prefer removing the space between currency and value except for currencies listed in currenciesToAllowSpaces
            return CURRENCY_CODES_TO_ALLOW_SPACES.indexOf(currency) >= 0
                ? formattedCurrency
                : formattedCurrency.replace(/\s/g, '');
        }
        else {
            return `${amount}`;
        }
    }
    else {
        return '';
    }
};
/**
 * Formats an amount as a currency based on given currency code, language and country code. Shows decimal based on flag.
 *
 * @param {number} amount
 * @param {string} currency
 * @param {string} language
 * @param {string} countryCode
 * @return {string}
 * @deprecated Still available, but direct use of this function is being deprecated.  Use formatCurrency instead.
 */
exports.getDisplayCurrencyWithLanguageCountry = (amount, currency, language, countryCode, showDecimalPlaces) => {
    return exports.getDisplayCurrencyWithLocale(amount, currency, common_1.formatLocale(language, countryCode), showDecimalPlaces);
};
/**
 * Formats an amount as a currency based on given currency code. Uses global window hl and co to determine
 * language and country code. Shows decimal based on flag.
 *
 * @param {number} amount
 * @param {string} currency
 * @return {string}
 * @deprecated Still available, but direct use of this function is being deprecated.  Use formatCurrency instead.
 */
exports.getDisplayCurrency = (amount, currency, showDecimalPlaces) => {
    return exports.getDisplayCurrencyWithLocale(amount, currency, common_1.getWindowLocale(), showDecimalPlaces);
};
/**
 * Formats an amount as a currency based on given currency code.
 * Optional country code, language and locale used to determine how to format it.
 * If a language is given, it will ignore the given locale,
 * and form a locale based on the given language and country code.
 * Falls back to using global window hl co if nothing is given.
 *
 * @param {FormatCurrencyArguments} paramsObject
 * @return {string}
 */
exports.formatCurrency = ({ amount, currency, language, countryCode = '', locale, showDecimalPlaces }) => {
    if (showDecimalPlaces === undefined) {
        showDecimalPlaces = getCurrencyDecimals(currency) !== 0;
    }
    if (language) {
        return exports.getDisplayCurrencyWithLanguageCountry(amount, currency, language, countryCode, showDecimalPlaces);
    }
    else if (locale) {
        return exports.getDisplayCurrencyWithLocale(amount, currency, locale, showDecimalPlaces);
    }
    else {
        return exports.getDisplayCurrency(amount, currency, showDecimalPlaces);
    }
};
// NOTE: copied from analyticsperf-plugin
// https://sourcegraph.corp.indeed.com/code.corp.indeed.com/employer-analytics/analyticsperf-plugin/-/blob/src/resources/webapp/static/scripts/util/CurrencyUtil/index.js
// Dictionary of currency codes mapped to their number of significant figures. Used to ensure consistency between
// numbers displayed in the table/active filters configured by the INTL api and the numbers we use to actually perform
// comparison operations. This list is not likely to update very often and there should never be a need to update the
// units.
// Created using data taken from: https://www.currency-iso.org/dam/downloads/lists/list_one.xml
exports.CURRENCY_UNITS_DICT = {
    AUD: 2,
    BRL: 2,
    CAD: 2,
    CHF: 2,
    EUR: 2,
    GBP: 2,
    INR: 2,
    JPY: 0,
    MXN: 2,
    SGD: 2,
    USD: 2
};
const DEFAULT_DECIMAL_PLACE = 2; // for 85% of currencies
function getCurrencyDecimals(currency) {
    return currency in exports.CURRENCY_UNITS_DICT ? exports.CURRENCY_UNITS_DICT[currency] : DEFAULT_DECIMAL_PLACE;
}
exports.getCurrencyDecimals = getCurrencyDecimals;
function getCurrencyMultiplier(currency) {
    return Math.pow(10, getCurrencyDecimals(currency));
}
exports.getCurrencyMultiplier = getCurrencyMultiplier;
function getIsSymbolAfter(locale) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(1).charAt(0) === '1';
}
exports.getIsSymbolAfter = getIsSymbolAfter;
function convertToMajor(amount, currency) {
    return Math.round(amount) / getCurrencyMultiplier(currency);
}
exports.convertToMajor = convertToMajor;
function convertToMinor(amount, currency) {
    return Math.round(amount * getCurrencyMultiplier(currency));
}
exports.convertToMinor = convertToMinor;
//# sourceMappingURL=data:application/json;base64,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